import type { PromotionalBanner } from '@/services/innovorder/promotionalBanner/promotionalBanner.type';

import { useBannerAction as useGenericBannerAction } from '@/pages/PromotionalBanners/hooks/useBannerAction';

export const useBannerAction = () => useGenericBannerAction<PromotionalBanner>();
